import axios from "axios";
import { multiUserApi } from "../../../../shared/utils/multiUserFunctions";

export const createApiInstance = (baseURL: string) => {
  const instance = axios.create({
    baseURL,
    withCredentials: false,
  });

  instance.interceptors.request.use((config) => {
    const keycloakToken = multiUserApi.getUserKey("access_token");
    if (keycloakToken) config.headers["X-Keycloak-Token"] = keycloakToken;

    return config;
  });

  return instance;
};
